module.exports = __webpack_public_path__ + "4fe2e4c8958ccdfbf97e24f062e3d0c0.svg";